<template>
  <ul class="leading-none">
    <template
      v-for="({ type, url }, index) in social"
      :key="`social-${type}-${index}`"
    >
      <li v-if="url">
        <NuxtLink class="inline-flex" :to="url" target="_blank" :title="type">
          <Icon
            v-if="type && icons[type]"
            :name="icons[type]"
            size="1.5em"
            class="text-black hover:text-gray-500"
          />
          <span v-else>{{ type }}</span>
        </NuxtLink>
      </li>
    </template>
    <li
      v-if="koFi && typeof koFi === 'object' && koFi.enabled"
      :class="koFi.class"
    >
      <ClientOnly>
        <span v-html="koFiButton"></span>
      </ClientOnly>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { SiteSettings } from "~/@types/siteSettings"
import type { SocialTypes } from "~/@types/utils"

const { koFi = { enabled: true } } = defineProps<{
  koFi?:
    | {
        enabled: boolean
        class?: string
      }
    | boolean
}>()

const koFiButton = ref("")
const { data: settings } = useNuxtData<SiteSettings>("site-settings")
const social = computed(() => settings.value?.social ?? [])

const icons: Partial<Record<SocialTypes, string>> = {
  threads: "ph:threads-logo",
  instagram: "mdi:instagram",
  linkedin: "mdi:linkedin",
}

onMounted(() => {
  if (typeof window !== "undefined" && window.kofiwidget2) {
    window.kofiwidget2.init("Support us on Ko-fi", "#000000", "G2G41D5OQF")
    koFiButton.value = window.kofiwidget2.getHTML()
  }
})
</script>
